import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { CircularProgress, MenuItem } from "@mui/material";

import Multiselect from "multiselect-react-dropdown";
import { setCustomisation } from "../redux/slices/customisationSlice";
import { red } from "@material-ui/core/colors";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/EditNote";
import Divider from "@mui/material/Divider";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  paddingTop: 1,
  paddingBottom: 4,
  paddingLeft: 4,
  paddingRight: 4,
  maxHeight:"90vh",
  overflowY:"auto"
};
const useStyles = makeStyles((theme) => ({
  // The Components dropdown paints its options with the brand green via the
  // library's inline `option` style. Inline styles beat the library's own
  // `li:hover` rule, so hover can't repaint the row -- this class restores a
  // visible hover/keyboard-highlight state on top of it.
  componentsDropdown: {
    "& .optionContainer li:hover, & .optionContainer li.highlightOption": {
      background: "#0F2E2A !important",
      color: "#fff !important",
    },
  },
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "32ch",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    width: 300,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: 5,
    overflow: "hidden",
  },
  customisation: {
    margin: "2%",
    width: "30ch",

    alignContent: "center",
    justifyContent: "center",
  },

  label: {
    fontWeight: "bold",
  },
  chip: {
    color: "black",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem",
  },
  divider: {
    margin: "20px 0",
  },
}));

export default function MyCustomisationForm({ selectedOption }) {
  const [open, setOpen] = React.useState(false);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");

  const handleClose = () => {
    setOpen(false);
    setShowAdvanced(false);
    setEditMode(false);
    setNewKey("");
    setNewValue("");
  };
  const headers = useSelector((state) => state.header);

  const classes = useStyles();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [options, setOptions] = useState([
    "Big Status",
    "Schedule",
    "Nearby Rooms",
    "Manager Booking",
    "ElhiTech Badging",
    "Navigator Room Filtering",
    "Modern Time Input",
    "Banquet",
    "Templates",
    "Kiosk",
    "Navigator Read-Only",
    "Manager Editing",
    "Navigator Self-Admin",
  ]);
  const [userOptions, setUserOptions] = useState(["ElhiTech Badging"]);
  const oldCustomisationData = useSelector((state) => state.customisations);
  const [error, setError] = useState(false);
  const curremms = useSelector((state) => state.curremms);
  const api = localStorage.getItem("api");
  const dispatch = useDispatch();
  const handleOpen = () => {
    setUserOptions(["ElhiTech Badging"]);
    setOpen(true);
  };

  const [formData, setFormData] = useState({
    logoUrl: "",
    name: "",
    components: "",
    backgroundImage: "",
    customProperties: {},
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));


  const emmsheaders = useSelector((state) => state.emmsheader);

  const handleSubmit = (event) => {
    event.preventDefault();

    setIsSubmitting(true);

    const json = {
      name: formData.name,
      logoUrl: formData.logoUrl,
      components: userOptions,
      backgroundImage: formData.backgroundImage,
      customProperties: formData.customProperties,
    };
    const json2 = { ...formData };
    json2.components = json;

    const requestBody = {
      path: "customisation",
      query: {},
      emmsId: `${selectedOption}`,
      body: { ...json },
      requestType: "POST",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    if (formData?.name.length == 0) {
      setErrorModalOpen(true);
      setError(true);
      setErrorMessage(`Please provide all required fields`);
      setFormData({
        name: "",
        logoUrl: "",
        components: "",
        backgroundImage: "",
        customProperties: {},
      });
    } else if (!formData.logoUrl.match(/\.(jpeg|jpg|png)$/i)) {
      setErrorModalOpen(true);
      setError(true);
      setErrorMessage(`Please provide a valid logo URL`);
      setFormData({
        name: "",
        logoUrl: "",
        components: "",
        backgroundImage: "",
        customProperties: {},
      });
    } else if (
      formData.backgroundImage.length > 0 &&
      !formData.backgroundImage.match(/\.(jpeg|jpg|png)$/i)
    ) {
      setErrorModalOpen(true);
      setError(true);
      setErrorMessage(`Please provide a valid background image`);
      setFormData({
        name: "",
        logoUrl: "",
        components: "",
        backgroundImage: "",
        customProperties: {},
      });
    } else {

      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          setIsSubmitting(false);

          const combinedData = [
            ...oldCustomisationData.customisations,
            response.data[0],
          ];

          dispatch(setCustomisation(combinedData));
          setErrorModalOpen(true);
          setErrorMessage(`Customisations added successfully`);
          setError(false);
          setFormData({
            name: "",
            logoUrl: "",
            components: "",
            backgroundImage: "",
            customProperties: {},
          });
        })
        .catch((error) => {
          setErrorModalOpen(true);
          setError(true);
          setErrorMessage(
            `Error adding customisations: ${error.response.data}`
          );
          setFormData({
            name: "",
            logoUrl: "",
            components: "",
            backgroundImage: "",
            customProperties: {},
          });
        });
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "sicp" && value == "elm") {
      const api = localStorage.getItem("api");
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          advanced: {
            sicpendpointkey: "elm",
            sicpendpoint: `${api}`,
          },
        },
      }));
    } else if (name === "sicp" && value == "emms") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          advanced: {
            sicpendpointkey: "emms",
            sicpendpoint: `${curremms.curremms.ipAddress}:${curremms.curremms.portNumber}`,
          },
        },
      }));
    } else if (name === "orientation" || name === "resolution") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          [name]: value,
        },
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };
  const handleModalClose = () => {
    setErrorModalOpen(false);
    setErrorMessage("");
    setOpen(false);
    setIsSubmitting(false);
  };

  const toggleAdvanced = () => {
    setShowAdvanced((prev) => {
      const newShowAdvanced = !prev;
      if (!newShowAdvanced) {
        setEditMode(false);
      }
      return newShowAdvanced;
    });
  };

  const toggleEditMode = () => {
    setEditMode((prev) => !prev);
  };

  const handleCustomPropertyChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      customProperties: {
        ...prevFormData.customProperties,
        [name]: value,
      },
    }));
  };

  const handleAddCustomProperty = () => {
    if (newKey && newValue) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          [newKey]: newValue,
        },
      }));
      setNewKey("");
      setNewValue("");
    }
  };

  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };
  return (
    <div>
      <Button
        style={{ textTransform: "none" }}
        variant="contained"
        color="primary"
        onClick={handleOpen}
      >
        Add Customisations
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form
            className={classes.root}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <div>
              <div>
                <h2>Customisations</h2>
                <h4 style={{ fontWeight: "100" }}>
                  Add customisation for {curremms?.curremms?.name}{" "}
                </h4>
              </div>
              {!showAdvanced && (
              <>
              <div style={{ display: "flex" }}>
                {getLabelWithAsterisk("Name:", true)}
                <TextField
                  required
                  id="name"
                  name="name"
                  label="Alias for Customisation"
                  size="small"
                  variant="outlined"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
              <div style={{ display: "flex" }}>
                {getLabelWithAsterisk("LogoURL:", true)}
                <TextField
                  required
                  id="logoUrl"
                  name="logoUrl"
                  label="in jpeg,jpg,png format"
                  size="small"
                  variant="outlined"
                  value={formData.logoUrl}
                  onChange={handleChange}
                />
              </div>
              <div style={{ display: "flex" }}>
                {getLabelWithAsterisk("Background Image:", false)}
                <TextField
                  id="backgroundImage"
                  name="backgroundImage"
                  label="in jpeg,jpg,png format"
                  variant="outlined"
                  size="small"
                  value={formData.backgroundImage}
                  onChange={handleChange}
                />
              </div>
              <div style={{ display: "flex" }}>
                {getLabelWithAsterisk("Components:", false)}
                <Multiselect
                  className={classes.componentsDropdown}
                  id="components"
                  name="components"
                  size="small"
                  label="Components"
                  value={formData.components}
                  isObject={false}
                  onRemove={(event) => setUserOptions(event)}
                  onSelect={(event) => setUserOptions(event)}
                  options={options}
                  selectedValues={userOptions}
                  style={{
                    chips: {
                      background: "#19433E",
                    },
                    option: {
                      background: "#19433E",
                      // Without an explicit colour the option text keeps the
                      // library's dark default and is unreadable on the green.
                      color: "#fff",
                    },

                    searchBox: {
                      border: "1px  solid lightgray",

                      width: isMobile ? "auto" : "29ch",
                      minHeight: "50px",
                    },
                    optionContainer: {
                      maxHeight: "100px",
                      overflowY: "auto",
                    },
                  }}
                />
              </div>

              <div style={{ display: "flex" }}>
                {getLabelWithAsterisk("SICP configuration:", true)}
                <TextField
                  required
                  id="sicp"
                  name="sicp"
                  size="small"
                  label="EMMS or ELM"
                  variant="outlined"
                  value={formData.sicp}
                  onChange={handleChange}
                  select
                >
                  <MenuItem value="emms">EMMS</MenuItem>
                  <MenuItem value="elm">ELM</MenuItem>
                </TextField>
              </div>
              <div style={{ display: "flex" }}>
                {getLabelWithAsterisk("Orientation:", true)}
                <TextField
                  required
                  id="orientation"
                  name="orientation"
                  size="small"
                  label="Landscape or Portrait"
                  variant="outlined"
                  value={formData?.customProperties?.orientation}
                  onChange={handleChange}
                  select
                >
                  <MenuItem value="landscape">Landscape</MenuItem>
                  <MenuItem value="portrait">Portrait</MenuItem>
                </TextField>
              </div>

              <div style={{ display: "flex", alignItems: "center" }}>
                {getLabelWithAsterisk("Resolution:", true)}
                <TextField
                  required
                  id="resolution"
                  name="resolution"
                  size="small"
                  label="Resolution (e.g., 1920x1080)"
                  variant="outlined"
                  value={formData.customProperties.resolution}
                  onChange={handleChange}
                />
              </div>
              </>
              )}
            </div>

            <div className={classes.buttonContainer}>
              <Button
                style={{ textTransform: "none" }}
                variant="outlined"
                color="primary"
                onClick={toggleAdvanced}
                startIcon={showAdvanced ? <ArrowBackIcon /> : null}
              >
                {showAdvanced ? "Back" : "Advanced"}
              </Button>
              {showAdvanced && (
                <Button
                  style={{
                    textTransform: "none",
                  }}
                  variant="contained"
                  color="primary"
                  onClick={toggleEditMode}
                  endIcon={!editMode ? <EditIcon /> : null}
                >
                  {editMode ? "Save Changes" : "Edit JSON"}
                </Button>
              )}
              {!showAdvanced && (
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                  }}
                >
                  <Button
                    style={{ textTransform: "none" }}
                    variant="outlined"
                    color="error"
                    onClick={() => setOpen(false)}
                    disabled={isSubmitting}
                  >
                    Close
                  </Button>
                  <Button
                    style={{
                      textTransform: "none",
                    }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? <CircularProgress size={24} /> : "Submit"}
                  </Button>
                </Box>
              )}
            </div>
            {showAdvanced && editMode && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Edit Custom Properties</h6>
                <div>
                  {Object.keys(formData.customProperties).map((key) => (
                    <div key={key} style={{ margin: "15px 0" }}>
                      <TextField
                        id={key}
                        name={key}
                        label={key}
                        variant="outlined"
                        size="small"
                        value={
                          typeof formData.customProperties[key] === "object"
                            ? JSON.stringify(formData.customProperties[key])
                            : formData.customProperties[key]
                        }
                        onChange={handleCustomPropertyChange}
                      />
                    </div>
                  ))}
                </div>
                {Object.keys(formData.customProperties).length > 0 && (
                  <div className={classes.divider}>
                    <Divider />
                  </div>
                )}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    id="newKey"
                    name="newKey"
                    label="New Key"
                    variant="outlined"
                    size="small"
                    value={newKey}
                    onChange={(e) => setNewKey(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <TextField
                    id="newValue"
                    name="newValue"
                    label="New Value"
                    variant="outlined"
                    size="small"
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <Button
                    style={{ textTransform: "none" }}
                    variant="contained"
                    color="primary"
                    onClick={handleAddCustomProperty}
                  >
                    Add
                  </Button>
                </div>
              </div>
            )}
            {showAdvanced && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Custom Properties</h6>
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    wordWrap: "break-word",
                  }}
                >
                  {JSON.stringify(formData.customProperties, null, 2)}
                </pre>
              </div>
            )}
            <Modal
              open={errorModalOpen}
              onClose={handleModalClose}
              className={classes.modal}
            >
              <div className={classes.paper}>
                <h2>{error === true ? "Oops" : "Congratulations"}</h2>
                <p>{errorMessage}</p>
                <Button
                  style={{ textTransform: "none", marginLeft: "75%" }}
                  onClick={handleModalClose}
                  variant="contained"
                  color="primary"
                >
                  Close
                </Button>
              </div>
            </Modal>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
